import React, { FC, useEffect, useRef } from 'react';
import {
	convertToOrdersFiltersInitial,
	getIntegrationPartnerOrderFiltersList,
	getOrderFiltersList,
	ORDERS_FILTERS_FORM_FIELDS,
	ORDERS_FILTERS_FORM_FIELDS_NAMES,
} from '../../constants/order/order-filters-form';
import {
	INTEGRATION_PARTNER_ORDER_FILTER_INPUTS,
	ORDER_FILTER_INPUTS,
} from '../../constants/order/order-filters-inputs';
import { useTranslation } from 'react-i18next';
import { FormInput } from '../merchants/FormInput';
import { InputType } from '../form/form-input-constants';
import { useOrdersContext } from '../../store/order/order-context';

import './OrdersFiltersSideModal.scss';
import { IOrderFilters } from '../../store/order/actions/order';
import { IAuthState } from '../../redux/AuthRedux';
import { shallowEqual, useSelector } from 'react-redux';
import { RootState } from '../../../setup';
import { checkRoles, CLAIMS } from '../../utils/roles-helper';
import { useWindowSize } from '../../constants/useWindowSize';
import clsx from 'clsx';
import { parseSearchParams } from '../../utils/utilities';
import { getFavoriteFiltersFromStorage } from '../../utils/filter-helpers';
import { getTableSort, getTableSortField } from '../../utils/linksHelper';
import { useLocation } from 'react-router';

interface Props {
	allStatuses: string[],
	formik: any,
}

export const OrdersFiltersSideModal: FC<Props> = (props) => {
	const { allStatuses, formik } = props;
	const { t } = useTranslation();
	const { search } = useLocation();
  const statusPicker = useRef(null);
  const favoriteFiltersPicker = useRef(null);
	const [width] = useWindowSize();
	const authUser: IAuthState = useSelector<RootState>(({ auth }) => auth, shallowEqual);

	const { orderContextState: { orderStatuses }} = useOrdersContext();

	useEffect(() => {
		const appliedFilters: IOrderFilters = parseSearchParams(search);
		const savedOrderFavoriteFilters: string[] = getFavoriteFiltersFromStorage('orders');

		if (appliedFilters) {
			const ordersFilters: IOrderFilters = {
				...appliedFilters,
				favoriteFilters: savedOrderFavoriteFilters ?? [],
			};
			const convertedSavedOrderFilters = convertToOrdersFiltersInitial(ordersFilters, orderStatuses);
			formik.setValues(convertedSavedOrderFilters);
		}
	}, []);

	const INPUTS = checkRoles(authUser, CLAIMS.INTEGRATION_PARTNER_ADMIN)
		? INTEGRATION_PARTNER_ORDER_FILTER_INPUTS({ t, statusesList: orderStatuses, statusPicker, allStatuses, formik })
		: ORDER_FILTER_INPUTS({ t, statusesList: orderStatuses, statusPicker, allStatuses, formik });

	const orderFiltersList = checkRoles(authUser, CLAIMS.INTEGRATION_PARTNER_ADMIN)
		? getIntegrationPartnerOrderFiltersList(t)
		: getOrderFiltersList(t);

	return (
		<form className="px-8 position-relative" onSubmit={formik.handleSubmit}>
			<div className="mb-10 me-3">
				<FormInput
					formik={formik}
					fieldName={ORDERS_FILTERS_FORM_FIELDS.FAVORITE_FILTERS}
					label={t(ORDERS_FILTERS_FORM_FIELDS_NAMES.FAVORITE_FILTERS)}
					placeholder={t(ORDERS_FILTERS_FORM_FIELDS_NAMES.FAVORITE_FILTERS)}
					inputType={InputType.MultiSelect}
					data={orderFiltersList}
					ref={favoriteFiltersPicker}
					allValue={orderFiltersList.map(item => item.value)}
					additionalClasses={clsx('col-12 col-sm-12 col-md-12', width < 490 ? 'favorite-filters-small-width' : 'favorite-filters-full-width')}
					isLabelIcon={true}
					tooltipText={t(ORDERS_FILTERS_FORM_FIELDS_NAMES.FAVORITE_FILTERS_TOOLTIP)}
					tooltipPlacement="right"
          key={ORDERS_FILTERS_FORM_FIELDS.FAVORITE_FILTERS}
				/>
			</div>
			<div className="row me-0">
				{
					INPUTS.map(item => (
						<FormInput
							{...item}
							formik={formik}
							key={item.key}
						/>
					))
				}
			</div>

		</form>
	);
};
